import styled from '@emotion/styled';
import themed from '../../../../ui/themer/themed';
import Responsive from '../../../../ui/utils/Responsive';

export const SuccessBar = styled.div`
	background: ${themed(({ color }) => color.state.success)};
	color: ${themed(({ color }) => color.text.inverted)};
	padding: 16px;
	text-align: center;
	max-width: 526px;
	position: fixed;
	left: 50%;
	bottom: 0;
	transform: translate(-50%, -50%);
	margin: 0 auto;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		width: 100%;
		max-width: 90%;
	}
`;

SuccessBar.defaultProps = {
	role: 'alert',
};
